var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41.51C4.543.28.5 4.178.5 9v5.75a2.752 2.752 0 0 0 2.512 2.737A3.76 3.76 0 0 0 6.75 21h.507c.228.302.587.5.993.5h1.5c.689 0 1.25-.56 1.25-1.25S10.439 19 9.75 19h-1.5c-.406 0-.765.198-.993.5H6.75a2.23 2.23 0 0 1-2.226-2h.726a.75.75 0 0 0 .75-.75v-5a.75.75 0 0 0-.75-.75H2V9a6.987 6.987 0 0 1 7.339-6.992C13.096 2.184 16 5.43 16 9.218V11h-3.25a.75.75 0 0 0-.75.75v5c0 .414.335.75.75.75h2a2.753 2.753 0 0 0 2.75-2.75V9.219c0-4.557-3.51-8.494-8.09-8.71Z",
    fill: "#BFC3D1"
  })));
};

export default SvgSupport;